const STORAGE_KEY = 'moi-pol-cookie-consent';
const STORAGE_VALUE = 'accepted';

function isAccepted() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === STORAGE_VALUE;
  } catch (error) {
    return false;
  }
}

function saveAcceptance() {
  try {
    window.localStorage.setItem(STORAGE_KEY, STORAGE_VALUE);
  } catch (error) {
    // The notice still closes for the current page when storage is unavailable.
  }
}

export default () => {
  const notice = document.querySelector('[data-cookie-notice]');

  if (!notice || isAccepted()) {
    return;
  }

  const button = notice.querySelector('[data-cookie-accept]');

  notice.hidden = false;

  if (!button) {
    return;
  }

  button.addEventListener('click', () => {
    saveAcceptance();
    notice.hidden = true;
  });
};




// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/cookies-hide.js